import equals from 'shallow-equals'

import structureMatches from 'utils/structureMatches'

export default function createReducer(initialState, handlers) {
	return function reducer(state = initialState, action, ...rest) {
		if (action.type === '@@redux/INIT') {
			if (!state) {
				state = initialState
			} else if (!structureMatches(initialState, state)) {
				console.error('state structure mismatch', state, initialState, handlers)
				state = initialState
			}
		}
		let handler = handlers[action.type]
		if (handler) {
			let x = handler(state, action, ...rest)
			if (!equals(x, state)) return x
		}
		return state
	}
}



// WEBPACK FOOTER //
// ./src/utils/redux/createReducer.js